interface ImpactGaugeProps {
  score: number;
  size?: number;
  label: string;
}

function riskColor(score: number): string {
  if (score <= 25) return "#16a34a";
  if (score <= 50) return "#ca8a04";
  if (score <= 75) return "#ea580c";
  return "#dc2626";
}

export function ImpactGauge({ score, size = 200, label }: ImpactGaugeProps) {
  const strokeW = size * 0.1;
  const radius = size * 0.35;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.min(Math.max(score, 0), 100);
  const offset = circumference - (clamped / 100) * circumference;
  const color = riskColor(clamped);

  return (
    <div className="flex flex-col items-center gap-3">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {/* Background track */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#1e293b"
          strokeWidth={strokeW}
        />
        {/* Score arc */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeW}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{
            filter: `drop-shadow(0 0 8px ${color}44)`,
            transition: "stroke-dashoffset 0.8s ease-out",
          }}
        />
        {/* Score text */}
        <text
          x={size / 2}
          y={size / 2 - size * 0.06}
          textAnchor="middle"
          dominantBaseline="central"
          fontSize={size * 0.2}
          fontFamily="Space Grotesk, system-ui, sans-serif"
          fontWeight="bold"
          fill="#f1f5f9"
        >
          {Math.round(clamped)}
        </text>
        <text
          x={size / 2}
          y={size / 2 + size * 0.12}
          textAnchor="middle"
          dominantBaseline="central"
          fontSize={size * 0.08}
          fill="#64748b"
        >
          / 100
        </text>
      </svg>
      <span className="text-sm text-[#94a3b8] font-medium">{label}</span>
    </div>
  );
}
